import { getRuntimeConfig } from "../utils/config";

const rawApiBaseUrl = getRuntimeConfig<string>("API_BASE_URL", "");
const normalizedApiBaseUrl = rawApiBaseUrl.replace(/\/+$/, "");
export const API_BASE_URL = normalizedApiBaseUrl.endsWith("/api")
  ? normalizedApiBaseUrl
  : `${normalizedApiBaseUrl}`;

export const RECAPTCHA_SITE_KEY = getRuntimeConfig<string>("RECAPTCHA_SITE_KEY");
export const API_TIMEOUT = parseInt(
  String(getRuntimeConfig<string | number>("API_TIMEOUT", "30000")),
  10
);

export const STORAGE_KEYS = {
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  USER: "user_data",
  /** companyId -> isIndividual (avoids menu/profile flash on reload) */
  ACCOUNT_TYPE: "account_type_cache",
  /** Partial onboarding user (no JWT) — survives refresh until full login */
  REGISTRATION_USER: "registration_user",
  DOMAIN: "company_domain",
  THEME: "theme_preference",
  LANGUAGE: "language_preference",
} as const;

export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  FEATURES: "/features",
  HOME_FEATURES: "/#features",
  DEMO: "/demo",
  PRICING: "/pricing",
  CONTACT: "/contact",
  FAQ: "/faq",
  PRIVACY: "/privacy",
  DATA_POLICY: "/data-policy",
  TERMS: "/terms",
  LOGIN: "/login",
  FORGOTPASSWORD: "/forgotpassword",
  FORGOTPASSWORD_WITH_ID: "/forgotpassword/:id",
  REGISTER: "/register",
  REGISTER_Package: "/register/:id",
  DASHBOARD: "/dashboard",
  EMPLOYEES: "/employees",
  EMPLOYEE_NEW: "/employees/new",
  EMPLOYEE_EDIT: "/employees/:id/edit",
  EMPLOYEE_VIEW: "/employees/:id/view",
  EMPLOYEE_SCANS: "/employees/:id/scans",
  EMPLOYEE_PUBLIC: "/employees/:key/*",
  INDIVIDUAL_PUBLIC: "/individuals/:key/*",
  NOT_FOUND: "/not-found",
  FORGOT_PASSWORD: "/forgot-password",
  USERS: "/users",
  USER_NEW: "/users/new",
  USER_EDIT: "/users/:id/edit",
  USER_VIEW: "/users/:id/view",
  LICENSES: "/licenses",
  COMPANIES: "/companies",
  INDIVIDUALS: "/individuals",
  INDIVIDUAL_SCANS: "/individuals/:id/scans",
  COMPANY_NEW: "/companies/new",
  /** Query: ?accountType=company | individual (locks type on new form) */
  ACCOUNT_TYPE_COMPANY: "company",
  ACCOUNT_TYPE_INDIVIDUAL: "individual",
  COMPANY_EDIT: "/companies/:id/edit",
  COMPANY_VIEW: "/companies/:id/view",
  COMPANY_SCANS: "/companies/:id/scans",
  COMPANY_PROFILE: "/company/:id/profile",
  MY_PROFILE: "/my-profile",
  PACKAGES: "/packages",
  PACKAGE_NEW: "/packages/new",
  PACKAGE_EDIT: "/packages/:id/edit",
  PACKAGE_VIEW: "/packages/:id/view",
  CONTACTUS: "/contactus",
  CONTACTUS_VIEW: "/contactus/:id/view",
  LOOKUPS: "/lookups",
  LOOKUP_NEW: "/lookups/new",
  LOOKUP_EDIT: "/lookups/:id/edit",
  UPGRADE_PACKAGE: "/upgrade",
  RENEW_PACKAGE: "/renew",
  /** @deprecated Use UPGRADE_PACKAGE — kept for legacy redirects */
  UPGRADE_PAYMENT: "/upgrade-payment",
  UPGRADE_PAYMENT_WITH_ID: "/upgrade-payment/:id",
  INVOICES: "/invoices",
  PRICING_PLAN_COMPANY: "company",
  PRICING_PLAN_INDIVIDUAL: "individual",
} as const;

export const VALIDATION_PATTERNS = {
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  PASSWORD:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  PHONE: /^[\d\s\-+()]+$/,
  URL: /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/,
} as const;

export const VALIDATION_MESSAGES = {
  REQUIRED: "This field is required",
  EMAIL_INVALID: "Please enter a valid email address",
  PASSWORD_WEAK:
    "Password must be at least 8 characters with uppercase, lowercase, number and special character",
  PASSWORD_MISMATCH: "Passwords do not match",
  MIN_LENGTH: (min: number) => `Must be at least ${min} characters`,
  MAX_LENGTH: (max: number) => `Must be no more than ${max} characters`,
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const TOAST_DURATION = {
  SHORT: 3000,
  MEDIUM: 5000,
  LONG: 7000,
} as const;

export enum DemoPackageId {
  Company = 1,
  Individual = 5,
}